module.exports = __webpack_public_path__ + "static/media/preloader.a4cf52fe.gif";